import { render, staticRenderFns } from "./AnnexFileUpload.vue?vue&type=template&id=f742edd8&scoped=true"
import script from "./AnnexFileUpload.vue?vue&type=script&lang=js"
export * from "./AnnexFileUpload.vue?vue&type=script&lang=js"
import style0 from "./AnnexFileUpload.vue?vue&type=style&index=0&id=f742edd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f742edd8",
  null
  
)

export default component.exports